import qs from "qs";
import {
    ID_FILTER_CODE,
    ID_FILTER_CONTRACTOR,
    ID_FILTER_DEALERS,
    ID_FILTER_DMS,
    ID_FILTER_LEGAL_ENTITIES,
    ID_FILTER_NAME,
    ID_FILTER_PRINTOUT_CREATIONDATEFROM,
    ID_FILTER_PRINTOUT_CREATIONDATETO,
    ID_FILTER_PRINTOUT_SENTDATEFROM,
    ID_FILTER_PRINTOUT_SENTDATETO,
    ID_FILTER_SEARCH,
    ID_FILTER_STATUSES
} from "../../pages/royalties/constants/RoyaltiesFilters";
import {FilterDef, HTTPGenericResponse} from "../../constants/FinanceModels";
import {getFilterValue} from "../../utils/FilterUtils";
import {useApi} from "../Api";
import dayjs from "dayjs";
import {RoyaltyContractor} from "../../pages/royalties/constants/RoyaltiesModels";
import {useContext} from "react";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";

export const useRoyaltiesPrintoutRepository = () => {

    const { GET, PUT, DELETE } = useApi();

    const PATH = "/finance/contractor"

    const {  globalData: { user } } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);


    function getContractors(legalEntity?: string, dealer?: string): Promise<RoyaltyContractor[]> {
        let params = {
            legalEntity: legalEntity ? [legalEntity] : allLegalEntities,
            dealer: dealer
        }
        return GET(`${PATH}/find`, {params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) }, false);
    }
   
    function getContractorsList(): Promise<RoyaltyContractor[]> {
        let legalEntities = allLegalEntities;
        let params = {
            legalEntities
        }
        return GET(`${PATH}/findContractors`, {params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) }, false);
    }

       
    async function getFindTypesContractor(): Promise<RoyaltyContractor[]> {
        let legalEntities = allLegalEntities;
        let params = {
            legalEntities
        }
        return GET(`${PATH}/find-types`, {params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) }, false);
    }

    async function getContractorsCodes(): Promise<string[]> {
        let contractors = await getContractors();
        return new Promise((resolve) => {
            resolve(contractors.map((it) => it.code).filter((it) => it !== null));
        });
    }
    async function getContractorsNames(): Promise<string[]> {
        let contractors = await getContractors();
        return new Promise((resolve) => {
            resolve(contractors.map((it) => it.name).filter((it) => it !== null));
        });
    }

    async function retrieveDms(contractorId : any): Promise<string[]> {
        let legalEntities = allLegalEntities;
        let params = {
            legalEntities
        }
        return GET(`${PATH}/retrieveDms/`+contractorId,  {params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) }, false);
    }


    function getPrintouts(offset: number, limit: number, sort: string | null, order: string | null, filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let ctName = getFilterValue(ID_FILTER_NAME, filterDefs);
        let msName = getFilterValue(ID_FILTER_DMS, filterDefs);
        let ctCode = getFilterValue(ID_FILTER_CODE, filterDefs);
        let ctType = getFilterValue(ID_FILTER_CONTRACTOR, filterDefs);
        let statuses = getFilterValue(ID_FILTER_STATUSES, filterDefs);
        let creationDateFrom: Date = getFilterValue(ID_FILTER_PRINTOUT_CREATIONDATEFROM, filterDefs);
        let creationDateTo: Date = getFilterValue(ID_FILTER_PRINTOUT_CREATIONDATETO, filterDefs);
        let sentDateFrom: Date = getFilterValue(ID_FILTER_PRINTOUT_SENTDATEFROM, filterDefs);
        let sentDateTo: Date = getFilterValue(ID_FILTER_PRINTOUT_SENTDATETO, filterDefs);
        let legalEntities: string[] = getFilterValue(ID_FILTER_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_DEALERS, filterDefs);

        let params = {
            offset: offset,
            limit: limit,
            sort: sort === "royaltyPrintoutRequestName" ? "rpr.name" : sort === "royaltyPrintoutRequestCreationDate" ? "rpr.created" : sort ,
            order: order,
            search: search,
            msName: msName,
            ctName: ctName,
            ctCode: ctCode,
            ctType: ctType,
            statuses: statuses,
            creationDateFrom: creationDateFrom ? dayjs(creationDateFrom).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')  : null,
            creationDateTo: creationDateTo ? dayjs(creationDateTo).endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')  : null,
            sentFrom: sentDateFrom ? dayjs(sentDateFrom).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')  : null,
            sentTo: sentDateTo ? dayjs(sentDateTo).endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')  : null,
            legalEntities,
            dealers
        }

        return GET(`${PATH}/royalty-printout/all`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }


    function getPrintoutsByReportId(reportId: string): Promise<HTTPGenericResponse> {
        let legalEntities = allLegalEntities;

        let params = {
            royaltyPrintoutRequestId: reportId,
            legalEntities
        }

        return GET(`${PATH}/royalty-printout/all`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) }, true);
    }

    function getSummary(filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let ctName = getFilterValue(ID_FILTER_NAME, filterDefs);
        let ctCode = getFilterValue(ID_FILTER_CODE, filterDefs);
        let ctType = getFilterValue(ID_FILTER_CONTRACTOR, filterDefs);
        let msName = getFilterValue(ID_FILTER_DMS, filterDefs);
        let statuses = getFilterValue(ID_FILTER_STATUSES, filterDefs);
        let creationDateFrom: Date = getFilterValue(ID_FILTER_PRINTOUT_CREATIONDATEFROM, filterDefs);
        let creationDateTo: Date = getFilterValue(ID_FILTER_PRINTOUT_CREATIONDATETO, filterDefs);
        let sentDateFrom: Date = getFilterValue(ID_FILTER_PRINTOUT_SENTDATEFROM, filterDefs);
        let sentDateTo: Date = getFilterValue(ID_FILTER_PRINTOUT_SENTDATETO, filterDefs);
        let legalEntities: string[] = getFilterValue(ID_FILTER_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_DEALERS, filterDefs);

        let params = {
            search: search,
            ctName: ctName,
            ctCode: ctCode,
            ctType: ctType,
            msName: msName,
            statuses: statuses,
            creationDateFrom: creationDateFrom ? dayjs(creationDateFrom).toISOString() : null,
            creationDateTo: creationDateTo ? dayjs(creationDateTo).toISOString() : null,
            sentDateFrom: sentDateFrom ? dayjs(sentDateFrom).toISOString() : null,
            sentDateTo: sentDateTo ? dayjs(sentDateTo).toISOString() : null,
            legalEntities,
            dealers
        }

        return GET(`${PATH}/royalty-printout/all-status-summary`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function getSummaryByReportId(id: string): Promise<HTTPGenericResponse> {
        let legalEntities = allLegalEntities;
        let params = {
            printoutRequestId: id,
            legalEntities
        }

        return GET(`${PATH}/royalty-printout/all-status-summary`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function publishPrintouts(ids: string[]): Promise<HTTPGenericResponse> {
        return PUT(`${PATH}/royalty-printout-publish`, ids, {}, true);
    }

    function deletePrintout(id: string) {
        return DELETE(`${PATH}/royalty-printout/${id}`, {}, true);
    }

    function downloadPrintout(id: string, typeFile: string) {
        return GET(`${PATH}/royalty-printout/download/${id}/${typeFile}`);
    }

    return {
        getContractors,
        getPrintouts,
        getPrintoutsByReportId,
        getSummary,
        getSummaryByReportId,
        publishPrintouts,
        deletePrintout,
        downloadPrintout,
        getContractorsList,
        retrieveDms,
        getFindTypesContractor
    };
}
